/**
 * 판매몰(`source`) 코드 → 사람이 읽는 이름. 상품 정보 조사와 통합검색 상품 탭이 함께 쓴다.
 */
export const PRODUCT_SOURCE_LABELS: Record<string, string> = {
  oliveyoung: '올리브영',
  hwahae: '화해',
  musinsa: '무신사',
  kakaogift: '카카오선물하기',
  amazon: '아마존',
};

/** 판매몰을 세우는 순서. ⚠️ 국내몰 넷 뒤에 해외몰 — 서버의 `PRODUCT_SOURCE_ORDER` 와 같아야 한다 */
export const PRODUCT_SOURCE_ORDER = ['oliveyoung', 'hwahae', 'musinsa', 'kakaogift', 'amazon'];

/**
 * 해외 판매채널 — 보드를 국내/북미로 가르는 기준. 서버의 `OVERSEAS_SOURCES` 와 같아야 한다.
 *
 * ⚠️ 채널이 더 붙을 예정이라 **아마존 하나를 특별 취급하지 않는다** — 지역으로 가른다.
 */
export const OVERSEAS_PRODUCT_SOURCE_IDS = new Set(['amazon']);

/** 국내 판매몰 수 — 해외몰을 뺀 수. 「국내 N개 몰」 문구가 이 값을 읽는다(몰이 늘면 문구가 따라온다) */
export const DOMESTIC_PRODUCT_SOURCE_COUNT = PRODUCT_SOURCE_ORDER.filter((id) => !OVERSEAS_PRODUCT_SOURCE_IDS.has(id)).length;
